// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "NextPrevious-module--bx--text-truncate--end--1DI6W";
export var bxTextTruncateFront = "NextPrevious-module--bx--text-truncate--front--XdJ-o";
export var wrapper = "NextPrevious-module--wrapper--jrIYs";
export var grid = "NextPrevious-module--grid--GqZX9";
export var linkContainer = "NextPrevious-module--link-container--An4-N";
export var link = "NextPrevious-module--link--gGvZe";
export var direction = "NextPrevious-module--direction--89Gg9";
export var name = "NextPrevious-module--name--7U7xJ";
export var isHomepage = "NextPrevious-module--isHomepage--GEYYy";